import { render, staticRenderFns } from "./Upgrader.vue?vue&type=template&id=833635d6&scoped=true"
import script from "./Upgrader.vue?vue&type=script&lang=js"
export * from "./Upgrader.vue?vue&type=script&lang=js"
import style0 from "./Upgrader.vue?vue&type=style&index=0&id=833635d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833635d6",
  null
  
)

export default component.exports